import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMobileServiceAppointmentsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['Int']['input'];
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  orderBy?: Types.InputMaybe<Array<Types.Appointments_Order_By> | Types.Appointments_Order_By>;
  typeFilter?: Types.Appointments_Bool_Exp;
  statusFilter?: Types.Appointments_Bool_Exp;
}>;


export type GetMobileServiceAppointmentsQuery = { __typename?: 'query_root', appointments: Array<{ __typename?: 'appointments', id: number, type: string, source: string, appointment_time?: string | null, consumer_name?: string | null, consumer_phone?: string | null, ro_number?: string | null, pickup_location_id?: number | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_year?: number | null, vehicle_vin?: string | null, vehicle_color?: string | null, status: string, config?: object | null, driver_notes?: string | null, createdat: string, createdby: string, pickup?: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null } | null, customer: { __typename?: 'customers', name?: string | null }, service_orders: Array<{ __typename?: 'service_orders', id: number, stop: { __typename?: 'mobility_stops', id: number, stop_order: number, run: { __typename?: 'mobility_runs', id: number, status: string } } }> }>, appointments_aggregate: { __typename?: 'appointments_aggregate', aggregate?: { __typename?: 'appointments_aggregate_fields', count: number } | null } };


export const GetMobileServiceAppointmentsDocument = gql`
    query getMobileServiceAppointments($customerId: Int!, $start: timestamptz!, $end: timestamptz!, $limit: Int!, $offset: Int!, $orderBy: [appointments_order_by!], $typeFilter: appointments_bool_exp! = {}, $statusFilter: appointments_bool_exp! = {}) {
  appointments(
    where: {_and: [$typeFilter], customer_id: {_eq: $customerId}, _or: [{appointment_time: {_gte: $start, _lte: $end}}, {appointment_time: {_is_null: true}}]}
    order_by: $orderBy
    limit: $limit
    offset: $offset
  ) {
    id
    type
    source
    appointment_time
    consumer_name
    consumer_phone
    ro_number
    pickup_location_id
    pickup {
      id
      name
      address
      latitude
      longitude
    }
    vehicle_make
    vehicle_model
    vehicle_year
    vehicle_vin
    vehicle_color
    status
    config
    driver_notes
    createdat
    createdby
    customer {
      name
    }
    service_orders {
      id
      stop {
        id
        stop_order
        run {
          id
          status
        }
      }
    }
  }
  appointments_aggregate(
    where: {_and: [$typeFilter, $statusFilter], customer_id: {_eq: $customerId}, _or: [{appointment_time: {_gte: $start, _lte: $end}}, {appointment_time: {_is_null: true}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetMobileServiceAppointmentsQuery__
 *
 * To run a query within a React component, call `useGetMobileServiceAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileServiceAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileServiceAppointmentsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      typeFilter: // value for 'typeFilter'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetMobileServiceAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<GetMobileServiceAppointmentsQuery, GetMobileServiceAppointmentsQueryVariables> & ({ variables: GetMobileServiceAppointmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMobileServiceAppointmentsQuery, GetMobileServiceAppointmentsQueryVariables>(GetMobileServiceAppointmentsDocument, options);
      }
export function useGetMobileServiceAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileServiceAppointmentsQuery, GetMobileServiceAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMobileServiceAppointmentsQuery, GetMobileServiceAppointmentsQueryVariables>(GetMobileServiceAppointmentsDocument, options);
        }
// @ts-ignore
export function useGetMobileServiceAppointmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMobileServiceAppointmentsQuery, GetMobileServiceAppointmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobileServiceAppointmentsQuery, GetMobileServiceAppointmentsQueryVariables>;
export function useGetMobileServiceAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobileServiceAppointmentsQuery, GetMobileServiceAppointmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMobileServiceAppointmentsQuery | undefined, GetMobileServiceAppointmentsQueryVariables>;
export function useGetMobileServiceAppointmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobileServiceAppointmentsQuery, GetMobileServiceAppointmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMobileServiceAppointmentsQuery, GetMobileServiceAppointmentsQueryVariables>(GetMobileServiceAppointmentsDocument, options);
        }
export type GetMobileServiceAppointmentsQueryHookResult = ReturnType<typeof useGetMobileServiceAppointmentsQuery>;
export type GetMobileServiceAppointmentsLazyQueryHookResult = ReturnType<typeof useGetMobileServiceAppointmentsLazyQuery>;
export type GetMobileServiceAppointmentsSuspenseQueryHookResult = ReturnType<typeof useGetMobileServiceAppointmentsSuspenseQuery>;
export type GetMobileServiceAppointmentsQueryResult = Apollo.QueryResult<GetMobileServiceAppointmentsQuery, GetMobileServiceAppointmentsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (appointments, appointments_aggregate): returns the full response object.
 * @source {@link src/features/mobileService/queries/getMobileServiceAppointments.query.gql}
 */
export async function getMobileServiceAppointments(
  variables: GetMobileServiceAppointmentsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetMobileServiceAppointmentsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetMobileServiceAppointmentsQuery>(
    GetMobileServiceAppointmentsDocument,
    variables,
    requestOptions
  )
}